'use client';

import { Button, cn } from '@shared/components/shadcn';
import { useTranslations } from 'next-intl';
import { useRef } from 'react';
import { useTransactionsContext } from '../TransactionsContext';
import type { MonthKey } from '../types';
import { MonthChip } from './MonthChip';

type MonthsChipsSelectorProps = {
  selectedMonth: MonthKey;
  onMonthSelect: (monthKey: MonthKey) => void;
  className?: string;
  onScrollToOlderTransactions: () => void;
};

function MonthsChipsSelector({ selectedMonth, onMonthSelect, className, onScrollToOlderTransactions }: MonthsChipsSelectorProps) {
  const { namespace, last12Months } = useTransactionsContext();
  const t = useTranslations(namespace);
  const containerRef = useRef<HTMLDivElement>(null);

  return (
    <div ref={containerRef} className={cn('flex flex-row-reverse gap-2 flex-nowrap overflow-x-scroll hide-scrollbar', className)} data-track-container="Month Navigation">
      {last12Months.map(month => (
        <MonthChip key={month} month={month} namespace={namespace} isChecked={selectedMonth === month} onSelect={onMonthSelect} containerRef={containerRef} />
      ))}
      <Button variant="ghost" size="s" className="paragraph-explanatory px-4" onClick={onScrollToOlderTransactions} data-track-name="Older Transactions">
        {t('older_transactions_button')}
      </Button>
    </div>
  );
}

export { MonthsChipsSelector };
